import angular from 'angular';
import moment from 'moment';

import templateUrl from './unclaimed-rogers-work-orders-list.component.html';
import { containsInvariant } from '../../../../core/services/filter-util';

export const UnclaimedRogersWorkOrdersListComponent = {
    controller: UnclaimedRogersWorkOrdersListController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        workOrders: "<",
        filters: "<?",
        sort: "<?",
        claimWorkOrder: "&onClaimWorkOrder",
        changeFilters: "&onChangeFilters",
        changeSort: "&onChangeSort"
    }
};

function UnclaimedRogersWorkOrdersListController($uibModal, $q, utilityService) {
    'ngInject';
    const vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.filters = {};
    vm.workOrders;
    vm.claimWorkOrder;
    vm.changeFilters;
    vm.changeSort;
    vm.onAssignEmployee = onAssignEmployee;
    vm.onBulkAssignEmployee = onBulkAssignEmployee;
    vm.onChangeAllSelected = onChangeAllSelected;
    vm.onChangeSelected = onChangeSelected;
    vm.filteredWorkOrders;
    vm.onChangeFilter = onChangeFilter;

    function onInit() {
        vm.filters = vm.filters || {};
        vm.sort = vm.sort || "DivisionWorkOrderID";
        vm.filteredWorkOrders = angular.copy(vm.workOrders);
        updateAllSelected();
        vm.filteredWorkOrders.forEach(setWorkOrderAppointmentDate);
    }

    function onChanges(changesObj) {
        if (changesObj.workOrders) {
            vm.filteredWorkOrders = angular.copy(vm.workOrders);
            updateAllSelected();
            vm.filteredWorkOrders.forEach(setWorkOrderAppointmentDate);
        }
    }

    function onChangeAllSelected() {
        vm.filteredWorkOrders.forEach(function (workOrder) {
            workOrder.selected = vm.allSelected || false;
        });
    }

    function onChangeSelected(workOrder) {
        updateAllSelected();
    }

    function onAssignEmployee(workOrder) {
        $uibModal.open({
            component: "apexAssignWorkOrderEmployeeModal",
            resolve: {
                workOrders: function () {
                    return [workOrder];
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (value) {
            return vm.claimWorkOrder({ workOrder: workOrder, employee: value });
        }).catch(function (ex) {
            if (ex !== 'cancel') {
                throw ex;
            }
        });
    }

    function onBulkAssignEmployee() {
        const selectedWorkOrders = vm.filteredWorkOrders.filter(function (workOrder) {
            return workOrder.selected;
        });

        $uibModal.open({
            component: "apexAssignWorkOrderEmployeeModal",
            resolve: {
                workOrders: function () {
                    return selectedWorkOrders;
                }
            },
            windowClass: 'xx-dialog pagespinner',
            size: 'lg',
            backdrop: 'static'
        }).result.then(function (value) {
            // Assign the employee to each of the selected work orders.
            return $q.all(selectedWorkOrders.map(function (workOrder) {
                return vm.claimWorkOrder({ workOrder: workOrder, employee: value });
            }));
        }).catch(function (ex) {
            if (ex !== 'cancel') {
                throw ex;
            }
        });
    }

    /**
     * Update the allSelected value to false if no work orders are selected (vacuously),
     * true if all work orders are selected (and there are work orders), and null if a mix are selected.
     */
    function updateAllSelected() {
        vm.allSelected = vm.filteredWorkOrders.reduce(function (all, workOrder, i) {
            if (i === 0) {
                // Compare all other selected states to the first one.
                return all;
            }
            if (all === true && !workOrder.selected) {
                return null;
            }
            if (all === false && workOrder.selected) {
                return null;
            }
            return all;
        }, vm.filteredWorkOrders.length > 0 ? vm.filteredWorkOrders[0].selected || false : false);
    }

    function setWorkOrderAppointmentDate(workOrder) {
        const statusDates = workOrder.ProductOrders.reduce(function (statusDates, productOrder) {
            productOrder.StatusHistory.forEach(function (change) {
                if (!statusDates[change.Status.ProductOrderStatusType]
                    || change.EffectiveDate > statusDates[change.Status.ProductOrderStatusType]) {
                    statusDates[change.Status.ProductOrderStatusType] = change.EffectiveDate;
                }
            });
            return statusDates;
        }, {});
        workOrder.statusDates = statusDates;
        workOrder.appointmentDate = statusDates.Booked;
        workOrder.installedDate = statusDates.Installed;
        workOrder.cancelledDate = statusDates.Cancelled;
        workOrder.disconnectedDate = statusDates.Disconnect;
    }

    function onChangeFilter() {
        vm.filteredWorkOrders = angular.copy(vm.workOrders);
        updateAllSelected();
        vm.filteredWorkOrders.forEach(setWorkOrderAppointmentDate);

        vm.filteredWorkOrders = vm.filteredWorkOrders.filter(function (workOrder) {
            return (!vm.filters.DivisionWorkOrderID
                || containsInvariant(workOrder.DivisionWorkOrderID, vm.filters.DivisionWorkOrderID))
                && (!vm.filters.DivisionLeadID || containsInvariant(workOrder.Lead
                    ? workOrder.Lead.DivisionLeadID : null, vm.filters.DivisionLeadID))
                && (!vm.filters.Address || containsInvariant(workOrder.Address
                    || workOrder.CustomDetails.Address, vm.filters.Address))
                && (!vm.filters.OrderDate || moment(vm.filters.OrderDate).isSame(workOrder.OrderDate))
                && (!vm.filters.appointmentDate || moment(vm.filters.appointmentDate, 'day')
                    .isSame(workOrder.appointmentDate, 'day'))
                && (!vm.filters.installedDate || moment(vm.filters.installedDate, 'day').isSame(workOrder.installedDate, 'day'))
                && (!vm.filters.CompanyNumber
                    || containsInvariant(workOrder.CustomDetails.COMPANY_NUMBER, vm.filters.CompanyNumber))
                && (!vm.filters.AccountNumber
                    || containsInvariant(workOrder.CustomDetails.ACCOUNT_NUMBER, vm.filters.AccountNumber))
                && (!vm.filters.CustFirstName
                    || containsInvariant(workOrder.CustomDetails.CUST_FIRST_NAME, vm.filters.CustFirstName))
                && (!vm.filters.CustLastName
                    || containsInvariant(workOrder.CustomDetails.CUST_LAST_NAME, vm.filters.CustLastName))
                && (!vm.filters.MapAreaCode
                    || containsInvariant(workOrder.CustomDetails.MAP_AREA_CODE, vm.filters.MapAreaCode))
                && (!vm.filters.OutletNumber
                    || containsInvariant(workOrder.CustomDetails.OUTLET_NUMBER, vm.filters.OutletNumber))
                && (!vm.filters.ProductCampaignCode
                    || containsInvariant(workOrder.CustomDetails.PROD_CAMPAIGN_CODE, vm.filters.ProductCampaignCode))
                && (!vm.filters.SalesType || containsInvariant(
                    workOrder.CustomDetails.SALES_TYPE, vm.filters.SalesType))

        });
    }


}
